"use client";

import { c as _c } from "react/compiler-runtime";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import type { ApiDrop } from "@/generated/models/ObjectSerializer";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import React from "react";
interface SingleWaveDropVotesProps {
  readonly drop: ApiDrop;
}
export const SingleWaveDropVotes: React.FC<SingleWaveDropVotesProps> = t0 => {
  const $ = _c(22);
  const {
    drop
  } = t0;
  const {
    isVotingEnded,
    isWinner
  } = useDropInteractionRules(drop);
  const isPositive = drop.rating >= 0;
  const hasUserVoted = drop.context_profile_context?.rating !== undefined && drop.context_profile_context?.rating !== 0;
  const userVote = drop.context_profile_context?.rating ?? 0;
  const isUserVoteNegative = userVote < 0;
  const shouldShowUserVote = (isVotingEnded || isWinner) && hasUserVoted;
  const t1 = `tw-text-sm tw-font-bold tw-tabular-nums tw-tracking-tight ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"}`;
  let t2;
  if ($[0] !== drop.rating) {
    t2 = formatNumberWithCommas(drop.rating);
    $[0] = drop.rating;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== drop.rating || $[6] !== drop.rating_prediction) {
    t4 = <DropVoteProgressing current={drop.rating} projected={drop.rating_prediction} />;
    $[5] = drop.rating;
    $[6] = drop.rating_prediction;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  let t6;
  if ($[8] !== t5) {
    t6 = <span className="tw-text-sm tw-text-iron-500 tw-font-normal">{t5}{" "}{WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <div className="tw-flex tw-flex-wrap tw-items-baseline tw-gap-x-2">{t3}{t4}{t6}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== drop.wave.voting_credit_type || $[15] !== isUserVoteNegative || $[16] !== shouldShowUserVote || $[17] !== userVote) {
    t8 = shouldShowUserVote && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-text-iron-400 tw-font-normal">{WAVE_VOTING_LABELS[drop.wave.voting_credit_type]}</span></span></div></div>;
    $[14] = drop.wave.voting_credit_type;
    $[15] = isUserVoteNegative;
    $[16] = shouldShowUserVote;
    $[17] = userVote;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="tw-flex tw-flex-col tw-gap-3 tw-mt-1">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};